import React from 'react';
import { motion } from 'framer-motion';

const services = [
  {
    icon: '🧩',
    title: 'CFD Simulation Services',
    descriptionPoints: [
      'Advanced Computational Fluid Dynamics modeling for flow, mixing, and process optimization.',
      'Reactor design, energy efficiency evaluation, and performance prediction.',
      'Visualize and enhance process efficiency before fabrication.',
    ],
    industries: 'Water, Chemical, Food, Oil & Gas, Pharma, and Environmental systems.',
  },
  {
    icon: '🏗️',
    title: 'Customized Fabrication & System Integration',
    descriptionPoints: [
      'Design and fabrication of skid-mounted and modular process systems.',
      'Material options: SS, MS, FRP, or customized alloys for industrial-grade durability.',
      'Includes: Cavitation Reactors, Mixing Systems, Pilot Plants, and Bioreactors.',
    ],
    industries: 'Water Treatment, Chemical, Oil & Gas, Food, Cosmetic, and Bioenergy.',
  },
];

const EngineeringServices = () => {
  return (
    <section id="engineering-services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            ⚙️ Engineering & Simulation Services
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="bg-white rounded-lg shadow-xl p-8 border-t-4 border-blue-600"
            >
              <div className="text-6xl text-center mb-6">{service.icon}</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                {service.title}
              </h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6 text-lg">
                {service.descriptionPoints.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
              <p className="text-md font-semibold text-gray-800 border-t pt-4 mt-4">
                Industries: <span className="font-normal text-gray-600">{service.industries}</span>
              </p>
            </motion.div>
          ))}
        </div>

        {/* Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-16 flex flex-col sm:flex-row justify-center gap-6"
        >
          <a
            href="/services" // Placeholder link
            className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300 shadow-lg"
          >
            Explore Our Services
          </a>
          <a
            href="/contact" // Placeholder link, could open a quote form/modal
            className="inline-flex items-center justify-center px-8 py-4 border border-blue-600 text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50 transition-colors duration-300 shadow-lg"
          >
            Get a Quote
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default EngineeringServices;
